
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

import Layout from '../../../components/Layout/LoginLayout/LoginLayout';

import LoginService from './LoginService';

import './style.css';

import iconProfile from '../../../assets/profile.png';

function ForgotPassword() {

    const navigate = useNavigate();

    const [forgotPasswordVal, setForgotPasswordVal] = useState('');
    const [errorMessage, setErrorMessage] = useState('');


    async function redirectToForgotPasswordSuccess() {
        document.querySelector('.login-main')?.classList.add('loader');
        try {


            var response = await LoginService.ForgotPassword(forgotPasswordVal);

            if (response.data.isSuccess) {

                navigate('/Members/MemberForgotPasswordSuccess');

            }
            else {
                setErrorMessage("User not found");
            }

        }
        catch (err) {
            console.log('err:: ', err);

        }
        finally {
            document.querySelector('.login-main')?.classList.remove('loader');
        }
    }

    return (
        <Layout>

            <div className="login-form" style={{ marginRight: '10px', marginLeft: '10px' }}>
                <div className="font-green">
                    <h1>
                        Forgot Password
                    </h1>
                </div>
                <div style={{ fontSize: '16px' }}>
                    Enter the <span className="font-green font-bold">username</span> or <span className="font-green font-bold">email </span>
                    registered to your account and we'll send you email instructions to reset your password.
                </div>
                <br />


                <div>
                    <div className="icon-container">
                        <span className="icon-login"><img src={iconProfile} className="responsive-image" /></span>
                        <input type="text" className="textbox-green-350px" name="ForgotPassword" id="txtForgotPassword" placeholder="Username or Email Address"
                            onChange={(event) =>
                                setForgotPasswordVal(event.target.value)
                            } />

                    </div>
                    <br />
                    {(errorMessage) ? <div id="dvMessage" className="left-align font-size-17px active" >
                        {errorMessage}
                    </div> : ""}
                    <br />
                    <div className="center-middle">
                        <button type="button" id="btnSubmitForgotPassword" className="btn-green-100 center-middle" onClick={() => redirectToForgotPasswordSuccess()}>Submit</button>
                    </div>
                </div>
            </div>

        </Layout>

    );
}

export default ForgotPassword;